import * as React from "react";
import { useEffect, useState } from "react";
import LazyLoad from 'react-lazyload';
import LazyImage from "./LazyImage";
function FadingImage(_a) {
  var imageUrls = _a.imageUrls,
    senderName = _a.senderName;
  var _b = useState(0),
    index = _b[0],
    setIndex = _b[1];
  var _c = useState(false),
    hovered = _c[0],
    setHovered = _c[1];
  useEffect(function () {
    var timeout = setTimeout(function () {
      if (hovered) {
        updateIndex();
      }
    }, 2000);
    return function () {
      return clearTimeout(timeout);
    };
  });
  function updateIndex() {
    var newIndex = (index + 1) % imageUrls.length;
    setIndex(newIndex);
    setHovered(true);
  }
  if (imageUrls === null || imageUrls === undefined) {
    return /*#__PURE__*/React.createElement("img", {
      src: '/img/female.png',
      alt: 'Platzhalter Bild für ' + senderName
    });
  }
  var images = imageUrls.map(function (item, position) {
    var className = 'fadeOut';
    if (position === index) {
      className = 'fadeIn';
    }
    if (item === null) {
      return null;
    }
    return /*#__PURE__*/React.createElement(LazyLoad, {
      offset: [20, 20],
      key: position
    }, /*#__PURE__*/React.createElement(LazyImage, {
      url: item.urls["320"],
      className: className,
      position: position,
      placeHolder: position !== index,
      senderName: senderName
    }));
  });
  return /*#__PURE__*/React.createElement("span", {
    onMouseEnter: updateIndex,
    onTouchStart: updateIndex,
    onTouchEnd: function () {
      return setHovered(false);
    },
    onMouseLeave: function () {
      return setHovered(false);
    }
  }, images);
}
export default FadingImage;